import { Award } from "lucide-react";

export default function Awards({ data, items }) {
  const label = data?.label || "Recognition";
  const headline = data?.headline || "Trusted by couples. Recognised by the industry.";
  const subheadline = data?.subheadline || "";
  const awards = items && items.length ? items : (data?.items || []);

  if (!awards.length) return null;

  return (
    <section id="awards" data-testid="awards-section" className="bg-beige/50 py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <div className="reveal flex items-center justify-center gap-3 mb-5">
            <span className="h-px w-10 bg-gold" />
            <span className="eyebrow">{label}</span>
            <span className="h-px w-10 bg-gold" />
          </div>
          <h2
            data-testid="awards-headline"
            className="reveal font-display text-[2.25rem] leading-[1.05] sm:text-5xl md:text-6xl tracking-tight text-charcoal"
          >
            {headline}
          </h2>
          {subheadline ? (
            <p className="reveal mt-5 text-charcoal/70 font-light leading-relaxed">{subheadline}</p>
          ) : null}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
          {awards.map((a, i) => {
            const inner = (
              <div className="reveal group relative bg-ivory border border-beige p-7 md:p-9 flex flex-col items-center text-center min-h-[210px] justify-center hover:bg-white transition-colors">
                {a.image_url ? (
                  <img
                    src={a.image_url}
                    alt={a.title}
                    className="h-16 md:h-20 w-auto object-contain mb-5 grayscale group-hover:grayscale-0 transition-all"
                    loading="lazy"
                  />
                ) : (
                  <span className="h-14 w-14 mb-5 rounded-full border border-gold inline-flex items-center justify-center text-gold">
                    <Award className="h-6 w-6" strokeWidth={1.4} />
                  </span>
                )}
                <div className="font-display text-xl md:text-2xl text-charcoal leading-snug">{a.title}</div>
                {a.year ? (
                  <div className="mt-2 uppercase tracking-[0.25em] text-[10px] text-charcoal/55">{a.year}</div>
                ) : null}
              </div>
            );
            return a.link ? (
              <a key={a.id || a.title} href={a.link} target="_blank" rel="noopener noreferrer" data-testid={`awards-item-${i}`}>
                {inner}
              </a>
            ) : (
              <div key={a.id || a.title} data-testid={`awards-item-${i}`}>
                {inner}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
